
import BaseInfoMarker from '../../../common/info_markers/BaseInfoMarker';

export default {
  extends: BaseInfoMarker,
  name: 'DeleteAccountInfo',
  data() {
    return {
      title: 'Delete Account',
      // content: `
      //   Your PWR Lab account will be deleted. Deleted data will not be retrievable. This action is permanent, and cannot be undone.
      //   You will be removed from all Connected Data Sharing and you will not be able to send data to Connected Event Leaderboards.
      //   Consider Closing Account instead to continue with Data Sharing and/or Connected Events.
      // `,
      content: `
      Your PWR Lab account will be deleted. Deleted data will not be retrievable. This action is permanent, and cannot be undone. Any Data Sharing connections will be terminated and you will no longer be able to send data to Connected Event Leaderboards.
      `,
      hasManualLink: false,
    };
  },
};
